import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hmd_empty_link = _resolveComponent("hmd-empty-link")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_popconfirm, {
      class: "append-to-body",
      title: "删除以后不可恢复, 是否继续?",
      placement: "bottomRight",
      onConfirm: _ctx.onRemove
    }, {
      default: _withCtx(() => [
        _createVNode(_component_hmd_empty_link, { loading: _ctx.loading }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["onConfirm"])
  ]))
}